import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import type { StoreState } from './store-state'

// UI 상태
import popup from './popup/popup'
import toast from './toast/toast'
import badge from './badge/badge'

// 세션/부트스트랩 상태 (Electron IPC 로그인 흐름이 채운다)
import user from './api/user'
import autoLogin from './api/autoLogin'
import hospital from './api/hospital'
import servicesetting from './api/servicesetting'
import chatroom from './api/chatroom'
import SaaS from './saas/saas'

// FCM 푸시 수신 이벤트 버스
import remote_notification from './rm/rm'

// 예약시트 상태
import rm_reservationsheet from './reservationsheet/reservationsheet'
import V2Reservation from './V2Reservation/V2Reservation'
import V2ReservationCellConfig from './V2Reservation/V2ReservationCellConfig'
import V2WorkCode from './V2Reservation/V2WorkCode'
import V2WorkCodeFilter from './V2Reservation/V2WorkCodeFilter'
import V2Department from './V2Reservation/V2Department'
import V2Employee from './V2Reservation/V2Employee'
import V2WorkCodeWithinWorkState from './V2Reservation/V2WorkCodeWithinWorkState'

Vue.use(Vuex)

/** localStorage('vuex') 에 남길 모듈. 여기 없는 것은 새로고침하면 사라진다 */
const PERSISTED_MODULES: (keyof StoreState)[] = [
    'user',
    'autoLogin',
    'hospital',
    'servicesetting',
    'badge',
    'V2Reservation',
    'V2ReservationCellConfig',
    'V2WorkCode',
    'V2WorkCodeFilter',
    'V2Department',
    'V2Employee',
    'V2WorkCodeWithinWorkState',
]

const store = new Vuex.Store<StoreState>({
    modules: {
        popup,
        toast,
        badge,

        user,
        autoLogin,
        hospital,
        servicesetting,
        chatroom,
        SaaS,

        remote_notification,

        rm_reservationsheet,
        V2Reservation,
        V2ReservationCellConfig,
        V2WorkCode,
        V2WorkCodeFilter,
        V2Department,
        V2Employee,
        V2WorkCodeWithinWorkState,
    },
    plugins: [createPersistedState({ paths: PERSISTED_MODULES })],
    strict: process.env.NODE_ENV !== 'production',
})

export default store
